// extracted by mini-css-extract-plugin
export default {"container":"Dm-z","blurb":"Em-z","links":"Fm-z"};